import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { classnames } from '../../../helpers/classnames';
import arePropsEqual from '../../../helpers/arePropsEqual';
import { bem } from '../../../helpers/styles';
import { omit } from '../../../helpers/omit';

import styles from './Select.css';

function SelectComponent({
  options,
  value,
  onChange = () => null,
  placeholder,
  className,
  disabled,
  ...restProps
}) {
  const handleChange = useCallback(
    ({ target: { value } }) => {
      onChange(value);
    },
    [value, onChange],
  );
  const props = {
    value,
    onChange: handleChange,
    className: classnames([bem(styles, 'Select'), className]),
    placeholder,
  };

  return (
    <select disabled={disabled} {...props} {...omit(restProps, 'error', 'label', 'block')}>
      {placeholder && (
        <option disabled value="">
          {placeholder}
        </option>
      )}
      {options &&
        options.map((opt, key) => (
          <option key={key} value={opt.value}>
            {opt.label}
          </option>
        ))}
    </select>
  );
}

SelectComponent.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ),
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};

const Select = memo(SelectComponent, (oldProps, newProps) => {
  return arePropsEqual(oldProps, newProps);
});

export default Select;
